import React from 'react'
import { connect } from 'react-redux'
import SectionActions from '../../Redux/SectionRedux'
import FilesActions from '../../Redux/FilesRedux'
import FileUploader from '../FileUploader'

class CreateSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        title_id: '',
        title_en: '',
        subtitle: '',
        description: '',
        section_id: props.detail.id,
        image_file: '',
        pdf_file: ''
      },
      pdfIncluded: false
    }
  }

  componentDidMount =() => {
    this.props.resetFile()
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form[field] = filename
    this.setState({ form })
  }

  _inputChange = (e, f) => {
    e.preventDefault()
    let v = e.target.value
    let form = { ...this.state.form }
    form[f] = v
    this.setState({ form })
  }

  _submit = (e) => {
    if (e) e.preventDefault()
    let form = { ...this.state.form }
    let data = { form }
    this.props.postSubSection(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 500)
  }

  render () {
    return (
      <section style={{ width: '40vw' }}>
        <div className='title-block'>
          <h3 className='title'>Add Subsection</h3>
        </div>
        <form onSubmit={(e) => this._submit(e)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title (ID)</label>
            </div>
            <div className='col-9'>
              <input required value={this.state.form.title_id} className='form-control' placeholder='Input title' onChange={(e) => this._inputChange(e, 'title_id')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title (EN)</label>
            </div>
            <div className='col-9'>
              <input required value={this.state.form.title_en} className='form-control' placeholder='Input title' onChange={(e) => this._inputChange(e, 'title_en')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Subtitle</label>
            </div>
            <div className='col-9'>
              <input value={this.state.form.subtitle} className='form-control' placeholder='Input subtitle' onChange={(e) => this._inputChange(e, 'subtitle')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Description</label>
            </div>
            <div className='col-9'>
              <input value={this.state.form.description} className='form-control' placeholder='Input description' onChange={(e) => this._inputChange(e, 'description')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Boxed Image</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'section-image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>
                <a data-toggle='collapse' href='#collapse' role='button'>
                  Add PDF File?
                </a>
              </label>
            </div>
            <div className='col-9'>
              <div className='collapse' id='collapse'>
                <FileUploader setting={{ type: 'company-disclosure' }} onUploaded={(filename) => this._fileUploaded(filename, 'pdf_file')} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='submit' className='btn btn-primary'>Submit</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  section: state.section,
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  postSubSection: (data) => dispatch(SectionActions.postSubSectionRequest(data)),
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset())
})

export default connect(stateToProps, dispatchToProps)(CreateSection)



// WEBPACK FOOTER //
// ./src/Containers/Section/CreateSubSection.js